import { ref, watch, computed, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { isOrganizationLogoS3Key } from '@/mixins/Organization/OrganizationStorage.js'
import {
  loadOrgLogoPreviewUrl,
  revokeOrgLogoPreviewUrl,
} from '@/utils/orgLogoStorage'

function isLandingLogoKey(key) {
  const path = String(key || '').trim()
  if (!path) return false
  return (
    isOrganizationLogoS3Key(path) || /\.(png|jpe?g|webp|svg)$/i.test(path)
  )
}

export function useLoginLandingOrg() {
  const store = useStore()
  const logoPreviewUrl = ref(null)
  const logoPreviewIsBlob = ref(false)

  const landingOrgLoading = computed(() => store.state.landingOrgLoading)
  const landingOrgError = computed(() => store.state.landingOrgError)
  const landingOrganization = computed(() => store.state.landingOrganization)
  const loginTitle = computed(
    () => store.getters.landingOrgDisplayName || 'Yandle',
  )

  const loginBlocked = computed(
    () => landingOrgLoading.value || Boolean(landingOrgError.value),
  )

  async function loadLogoPreview(key) {
    revokeOrgLogoPreviewUrl(logoPreviewUrl.value, logoPreviewIsBlob.value)
    logoPreviewUrl.value = null
    logoPreviewIsBlob.value = false

    const path = String(key || '').trim()
    if (!isLandingLogoKey(path)) return

    try {
      const { url, isBlob } = await loadOrgLogoPreviewUrl(path)
      const current = String(
        landingOrganization.value?.org_logo_s3_key || '',
      ).trim()
      if (url && path === current) {
        logoPreviewUrl.value = url
        logoPreviewIsBlob.value = isBlob
      }
    } catch (err) {
      console.log('Logo load from S3 failed', err)
    }
  }

  watch(
    () => landingOrganization.value?.org_logo_s3_key,
    (key) => {
      loadLogoPreview(key)
    },
    { immediate: true },
  )

  onBeforeUnmount(() => {
    revokeOrgLogoPreviewUrl(logoPreviewUrl.value, logoPreviewIsBlob.value)
  })

  return {
    logoPreviewUrl,
    landingOrgLoading,
    landingOrgError,
    landingOrganization,
    loginTitle,
    loginBlocked,
  }
}
